module.exports = __webpack_public_path__ + "static/campaignforamericasfuture-377c3e8e21b72760da132c905cf1d4b9.png";